import request from './request';

// ======== 标签管理接口 ========

/**
 * 获取所有标签列表
 */
export function getAllTags() {
  return request({
    url: '/execution-plan-tags/tags',
    method: 'get'
  });
}

/**
 * 创建新标签
 */
export function createTag(data) {
  return request({
    url: '/execution-plan-tags/tags',
    method: 'post',
    data
  });
}

/**
 * 更新标签
 */
export function updateTag(tagId, data) {
  return request({
    url: `/execution-plan-tags/tags/${tagId}`,
    method: 'put',
    data
  });
}

/**
 * 删除标签
 */
export function deleteTag(tagId) {
  return request({
    url: `/execution-plan-tags/tags/${tagId}`,
    method: 'delete'
  });
}

// ======== 执行计划标签接口 ========

/**
 * 获取执行计划的标签列表
 */
export function getPlanTags(planId) {
  return request({
    url: `/execution-plan-tags/plans/${planId}/tags`,
    method: 'get'
  });
}

/**
 * 为执行计划添加标签
 */
export function addTagToPlan(planId, tagId) {
  return request({
    url: `/execution-plan-tags/plans/${planId}/tags/${tagId}`,
    method: 'post'
  });
}

/**
 * 从执行计划移除标签
 */
export function removeTagFromPlan(planId, tagId) {
  return request({
    url: `/execution-plan-tags/plans/${planId}/tags/${tagId}`,
    method: 'delete'
  });
}

/**
 * 按标签筛选执行计划列表
 */
export function filterPlansByTags(data) {
  return request({
    url: '/execution-plan-tags/plans/filter-by-tags',
    method: 'post',
    data
  });
}
